import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { useCoursesContext } from "../context/courses_context";
import StarRating from "../components/StarRating";
import { MdInfo } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { FaShoppingCart } from "react-icons/fa";
import { RiClosedCaptioningFill } from "react-icons/ri";
import { BiCheck } from "react-icons/bi";
import { useCartContext } from "../context/cart_context";
import { course_images } from "../utils/images";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import commentsData from "./comments.json";
import videoData from "./data";

const plyrProps = {
  source: {
    type: "video",
    title: "Example title",
    sources: [
      {
        src: "/path/to/movie.mp4",
        type: "video/mp4",
        size: 720,
      },
      {
        src: "/path/to/movie.webm",
        type: "video/webm",
        size: 1080,
      },
    ],
    poster: "/path/to/poster.jpg",
    previewThumbnails: {
      src: "/path/to/thumbnails.vtt",
    },
  }, // https://github.com/sampotts/plyr#the-source-setter
  // Direct props for inner video tag (mdn.io/video)
};

const VideoCoursePage = () => {
  const { id } = useParams();
  const { fetchingSingleCourse, single_course } = useCoursesContext();
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [comments, setComments] = useState(commentsData);
  const [comment, setComment] = useState("");
  const { addToCart } = useCartContext();

  // useEffect(() => {
  //   async function fetchData() {
  //     const data = await fetch(`${process.env.REACT_APP_BACKEND}/comments`);
  //   }
  //   fetchData();
  // }, []);

  useEffect(() => {
    fetchingSingleCourse(id);
  }, []);
  const {
    id: courseID,
    category,
    image,
    course_name,
    description,
    rating_count,
    rating_star,
    students,
    creator,
    updated_date,
    lang,
    actual_price,
    discounted_price,
    what_you_will_learn: learnItems,
    content,
  } = single_course;

  useEffect(() => {
    console.log(comments);
  }, [comments]);

  const handleSubmit = async (e) => {
    console.log(comment);
    if (!comment) return;
    const newOne = { message: comment, creator: "Eish Malvi" };
    setComments((comments) => [newOne, ...comments]);
    setComment("");
    document.querySelector("input").value = "";
  };

  return (
    <VideoCourseWrapper>
      <h1 style={{ textAlign: "center", paddingTop: "1em" }}>
        <u>The Power of Python</u>
      </h1>
      <div className="course-intro mx-auto sgrid">
        <div className="course-img">
          <Plyr
            source={{
              type: "video",
              title: `${videoData[currentVideoIndex]["title"]}`,
              sources: [
                {
                  src: `${videoData[currentVideoIndex]["videoUrl"]}`,
                  type: " video/mp4",
                },
              ],
              poster: `${videoData[currentVideoIndex]["videoUrl"]}`,
            }}
          />
        </div>
        <div className="playlist">
          <div
            className="playlist-container"
            style={{
              scrollbarWidth: "thin",
              scrollbarColor: "transparent transparent",
            }}
          >
            {videoData.map((item, index) => {
              return (
                <div
                  className={`playlist-item ${
                    currentVideoIndex === index ? "playlist-item-active" : ""
                  }`}
                  onClick={() => {
                    setCurrentVideoIndex(index);
                  }}
                >
                  <div style={{ width: "200px" }}>
                    <img
                      src={item["thumbnailUrl"]}
                      alt="thumbnail"
                      style={{ marginTop: "1em", marginLeft: "0.5em" }}
                    />
                  </div>

                  <div className="playlist-item-text">
                    <span>{item["title"]}</span>
                    <span>{item["time"]}min</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="course-full bg-white text-dark">
        <div className="course-content mx-auto">
          <div className="course-sc-title">Comments Section</div>
          <div className="mycommentsClass">
            <strong>Post Comment</strong>
            <div background-color="black">
              <input
                type="text"
                id="comment-box"
                onChange={(e) => setComment(e.target.value)}
                value={comment}
                style={{
                  border: "2px solid black",
                  width: "80%",
                  height: "3.3em",
                  padding: "0.5em",
                  fontSize: "1.2em",
                }}
              />
              <button
                onClick={() => {
                  handleSubmit();
                }}
                type="button"
                style={{
                  marginLeft: "1em",
                  background: "#F5F5CF",
                  padding: "1em",
                  border: "2px solid black",
                }}
              >
                Comment
              </button>
            </div>
            <ol className="alternating-colors">
              {comments.map((item, index) => {
                return (
                  <li>
                    <strong>{item["creator"]}</strong>
                    <p>{item["message"]}</p>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </VideoCourseWrapper>
  );
};
const VideoCourseWrapper = styled.div`
  background: #f5f5cf;
  color: black;

  .mycommentsClass {
    font-family: "Space Mono", monospace;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    padding: 32px;
    margin: 60px auto;
    border: 1px solid #eee;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.06);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizelegibility;
    letter-spacing: -0.25px;
  }

  ol {
    padding-left: 50px;
  }
  li {
    color: #4f4f4f;
    padding-left: 16px;
    margin-top: 24px;
    position: relative;
    font-size: 16px;
    line-height: 20px;

    &:before {
      content: "";
      display: block;
      height: 42px;
      width: 42px;
      border-radius: 50%;
      border: 2px solid #ddd;
      position: absolute; // yeah, you have to manually position it based on the text size, line height, etc. (in the parent li style). it's not the smarest solution
      top: -12px;
      left: -46px;
    }
  }

  strong {
    color: #292929;
  }

  ol.alternating-colors {
    li:nth-child(odd):before {
      border-color: #0bad02;
    }
    li:nth-child(even):before {
      border-color: #2378d5;
    }
  }

  .course-intro {
    padding: 40px 16px;
    max-width: 992px;

    .course-details {
      padding-top: 20px;
    }

    .course-category {
      padding: 0px 8px;
      border-radius: 6px;
    }

    .course-head {
      font-size: 38px;
      line-height: 1.2;
      padding: 12px 0 0 0;
    }
    .course-para {
      padding: 12px 0;
    }
    .rating-star-val {
      margin-right: 7px;
      padding-bottom: 5px;
      color: var(--clr-orange);
    }
    .students-count {
      margin-left: 8px;
    }
    .rating-count {
      margin-left: 6px;
      color: #d097f6;
    }
    .course-info {
      li {
        margin-bottom: 2px;
        &:nth-child(2) {
          margin-top: 10px;
        }
      }
      .course-info-txt {
        text-transform: capitalize;
        margin-left: 8px;
        margin-bottom: 4px;
      }
    }
    .course-price {
      margin-top: 12px;
      .old-price {
        color: #eceb98;
        text-decoration: line-through;
        margin-left: 10px;
      }
    }
    .course-btn {
      margin-top: 16px;
      .add-to-cart-btn {
        padding: 12px 28px;
        span {
          margin-left: 12px;
        }
      }
    }

    @media screen and (min-width: 880px) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 40px;
      .course-details {
        padding-top: 0;
      }
      .course-img {
        order: 2;
      }
    }

    .playlist {
      .playlist-container {
        margin-top: 1em;
        width: 1000px;
        height: 500px;
        border: 2px solid black;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        border-radius: 0.2em;
      }
      .playlist-item {
        display: flex;
        flex-direction: row;
        min-height: 150px;
        border: 1px solid black;
        margin: 0.5em;
        border-radius: 0.2em;
      }
      .playlist-item:hover:not(.playlist-item-active) {
        border: 2px solid black;
        cursor: pointer;
      }
      .playlist-item-active {
        border: 5px solid black;
      }
      .playlist-item-text {
        margin-left: 2em;
        margin-top: 1.5em;
        margin-bottom: 1.5em;
        font-weight: 500;
        font-size: 1.2em;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    @media screen and (min-width: 1400px) {
      grid-template-columns: 60% 40%;
    }
  }

  .course-full {
    padding: 40px 16px;
    .course-sc-title {
      font-size: 22px;
      font-weight: 700;
      margin: 12px 0;
    }
    .course-learn {
      max-width: 992px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-learn-list {
        li {
          margin: 5px 0;
          display: flex;
          span {
            &:nth-child(1) {
              opacity: 0.95;
              margin-right: 12px;
            }
          }
        }

        @media screen and (min-width: 992px) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    .course-content {
      max-width: 992px;
      margin-top: 30px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-content-list {
        li {
          background-color: #f7f9fa;
          padding: 12px 18px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          margin-bottom: 10px;
          font-weight: 800;
          font-size: 15px;
        }
      }
    }
  }
`;

function calculateTime(duration) {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
}

export default VideoCoursePage;
